import {
  Box, Divider, Typography,
} from '@mui/material';
import { useSelector } from 'react-redux';
import FemaleIcon from '@mui/icons-material/Female';
import { CheckInPlayer } from './CheckInPlayer';
import { EditPlayerName } from './EditPlayerName';
import { AdminPlayerMenu } from './AdminPlayerMenu';

export default function OfflinePlayerCard({
  player,
  position,
  ranking,
  isAdmin,
}) {
  const { showWinPercentage } = useSelector((state) => state.game);
  const playerPoints = player.totalPoints ?? (player.wins - player.losses);
  const totalGames = player.wins + player.losses;

  return (
    <Box sx={{
      width: { xs: '100%', md: '80%' },
    }}
    >
      <Box
        key={`${player.playerId}-${player.playerName}`}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 2,
          borderRadius: '5px',
          padding: '10px',
          width: '100%',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: 2,
          }}
        >

          <Typography variant="h6">
            {(player.dailyGames || 0) > 0 && (
              <Typography
                component="span"
                variant="body2"
                sx={{ color: 'primary.main', fontWeight: 'bold', mr: 0.5 }}
              >
                {showWinPercentage
                  ? `${Math.round(((player.dailyWins || 0) / (player.dailyGames || 1)) * 100)}%`
                  : `${player.dailyWins || 0}/${player.dailyGames || 0}`}
              </Typography>
            )}
            {(position && ranking) || isAdmin ? `${position}. ` : ''}
            {player.playerName}
            {' '}
            {(isAdmin || ranking) && `(${playerPoints > 100 ? 100 : playerPoints}) ${showWinPercentage && totalGames > 0 ? `${Math.round((player.wins / totalGames) * 100)}%` : `${player.wins}/${totalGames}`}`}
          </Typography>
          {player.gender === 'F' && <FemaleIcon sx={{ marginLeft: '-10px', color: 'deeppink', height: '30px' }} />}
        </Box>
        <Box
          sx={{
            display: 'flex',
            gap: 2,
          }}
        >
          {!isAdmin && <CheckInPlayer playerId={player.playerId} />}
          {isAdmin && <EditPlayerName playerId={player.playerId} />}
          {isAdmin && <AdminPlayerMenu playerId={player.playerId} />}
        </Box>
      </Box>
      <Divider variant="fullWidth" />
    </Box>
  );
}
